const header = document.querySelector("[data-header]");
const toggle = document.querySelector(".nav-toggle");
const nav = document.querySelector(".site-nav");

function updateHeader() {
  if (header) header.classList.toggle("is-scrolled", window.scrollY > 16);
}

if (toggle && nav) {
  toggle.addEventListener("click", () => {
    const isOpen = nav.classList.toggle("is-open");
    toggle.setAttribute("aria-expanded", String(isOpen));
  });

  nav.addEventListener("click", (event) => {
    const link = event.target.closest("a");

    if (link) {
      const dropdown = link.closest(".nav-dropdown");
      if (dropdown) dropdown.open = false;

      nav.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
    }
  });
}

window.addEventListener("scroll", updateHeader, { passive: true });
updateHeader();
